<template>
  <div
      class="input-container m-b-2"
      selenium="login-form-password-input-container">
    <div class="INPUT-GROUP">
      <input
          v-vk-input
          :ref="refName"
          :type="passwordFieldType"
          :disabled="disabled"
          :name="refName"
          v-model="newPassword"
          class="input flex-1-1"
          selenium="input"
          @input="$emit(`input`, $event.target.value)"
          @focus="$emit('focusChange' ,true)"
          @blur="$emit('focusChange' ,false)"
      >
      <label class="input-label" selenium="label">{{ label }}</label>
      <div class="INPUT-APPEND input p-l-0">
        <input
            :id="refName+'showpassword'"
            v-model="isPasswordVisible"
            tabindex="-1"
            :name="refName+'showpassword'"
            selenium="show-password-input"
            type="checkbox"
            @change="$refs[refName].focus()">
        <label
            class="text-lg p-y-1 d-flex ai-center link"
            :for="refName+'showpassword'"
            selenium="show-password-label">
          {{ showPasswordLabel }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'show-password',
  props: {
    refName: {
      type: String,
      default: 'password',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Password',
    },
  },
  data () {
    return {
      newPassword: '',
      isPasswordVisible: false,
    };
  },
  computed: {
    passwordFieldType () {
      return this.isPasswordVisible ? 'text' : 'password';
    },
    showPasswordLabel () {
      return this.isPasswordVisible ? 'Hide' : 'Show';
    },
  },
  methods: {
    focus () {
      this.$refs[this.refName].focus();
    },
    reset () {
      this.newPassword = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.INPUT-GROUP {
  display: flex;

  & > input {
    border-right: none;
  }

  & > input:focus + label + .INPUT-APPEND {
    border: $input-focus--border;
  }

  & > input:disabled + label + .INPUT-APPEND {
    cursor: $input-disabled--cursor;
    color: $input-disabled--color;
    border: $input-disabled--border;
  }
}

.INPUT-APPEND {
    width: auto;
    border-left: none !important;

    & > input {
      appearance: none;
      height: 0px;
      width: 0px;
      opacity: 0;
      position: absolute;
    }

    & > label {
      cursor: pointer;
      user-select: none;
    }
  }
</style>
